import selectInsurance from 'utils/selectInsurance';
import getPatientPhone2 from 'utils/print/getPatientPhone2';

const getInsuranceInsuredsPhone2 = ({ patient, insurance, value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  const selectedInsuranceRelationToInsured = selectedInsurance
    ? selectedInsurance['Relation to Insured']
    : 'none';
  if (selectedInsuranceRelationToInsured === 'Self') {
    return getPatientPhone2({
      ...otherProps,
      patient,
      insurance,
    });
  }

  return null;
};

export default getInsuranceInsuredsPhone2;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsPhone2.js